const normalizeReference = (value) => String(value ?? "").trim().toLocaleLowerCase();

export function matchesHelpReference(post, reference) {
    const normalizedReference = normalizeReference(reference);
    if (!normalizedReference) return false;

    const identifiers = [post?.documentId, post?.id].map(normalizeReference).filter(Boolean);
    return identifiers.includes(normalizedReference);
}

export function helpChecklistItems(values) {
    if (!Array.isArray(values)) return [];
    return values
        .filter((value) => typeof value === "string")
        .map((value) => value.trim())
        .filter(Boolean);
}

export function helpPostDescription(post, maxLength = 150) {
    const source = post?.description || post?.excerpt || post?.content || "";
    const plainText = String(source)
        .replace(/```[\s\S]*?```/g, " ")
        .replace(/!\[[^\]]*]\([^)]*\)/g, " ")
        .replace(/\[([^\]]+)]\([^)]*\)/g, "$1")
        .replace(/<[^>]+>/g, " ")
        .replace(/[#>*_`~|]/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    if (plainText.length <= maxLength) return plainText;
    return `${plainText.slice(0, Math.max(0, maxLength - 1)).trimEnd()}…`;
}
